var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4333_26715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3334C14.6022 18.3334 18.3332 14.6025 18.3332 10.0001C18.3332 5.39771 14.6022 1.66675 9.99984 1.66675C5.39746 1.66675 1.6665 5.39771 1.6665 10.0001C1.6665 14.6025 5.39746 18.3334 9.99984 18.3334Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 13.3334C11.8408 13.3334 13.3332 11.841 13.3332 10.0001C13.3332 8.15913 11.8408 6.66675 9.99984 6.66675C8.15889 6.66675 6.6665 8.15913 6.6665 10.0001C6.6665 11.841 8.15889 13.3334 9.99984 13.3334Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.50008L15.8333 4.16675",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 15.8333L7.49984 12.5",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 7.50008L4.1665 4.16675",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 15.8333L12.5 12.5",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4333_26715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.5cd3c95bb1eda0a046783691e07e31fe.svg";
export { ForwardRef as ReactComponent };